export default {
  en: {
    title: "",
  },
  pl: {
    gdansk: {
      title: "Wyjątkowe miejsce",
      address: "Wydział Biologii Uniwersytetu Gdańskiego - ul. Wita Stwosza 59, 80-515 Gdańsk",
      desc: `W tym roku Hack4Change przenosi się w niezwykle inspirujące miejsce – na <strong>Wydział Biologii Uniwersytetu Gdańskiego (ul. Wita Stwosza 59)!</strong> 🌿🧬<br/><br/>
Ta wyjątkowa przestrzeń, w której nauka łączy się z innowacjami stworzy niepowtarzalny klimat do twórczej pracy i szukania nieszablonowych rozwiązań. W takim otoczeniu pomysły na projekty zmieniające świat rodzą się same!<br/><br/>
Dbamy o Wasz <i>tech-life balance</i>, dlatego zielone otoczenie kampusu wykorzystamy na maksa! Poza intensywną pracą nad kodem zaplanowaliśmy dla Was aktywności rozluźniające na świeżym powietrzu oraz przestrzeń do relaksu i networkingu wśród natury.`,
    },
  },
}
